<template>
    <div class="myContent">
        <!-- 侧边栏 -->
        <div class="myNavBox">
            <div class="myNav align" v-for="(item,index) in myNavData" :key="index" @click="myNavTap(item)">
                <el-image :src="active == index ? item.iconOn : item.icon" fit="cover" class="myNavIcon"></el-image>
                <div class="myNavName" :style="{color: active == index ? '#FF6A00' : '#606263'}">{{ item.name }}</div>
            </div>
        </div>
        <!-- 右侧组件 -->
        <div class="myComponents">
            <order v-if="$route.query.type == 'order'"></order>
            <orderDetail v-if="$route.query.type == 'orderDetail'"></orderDetail>
            <contact v-if="$route.query.type == 'contact'"></contact>
            <identity v-if="$route.query.type == 'identity'"></identity>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                active: 0,
                myNavData: [
                    {
                        name: '我的订单',
                        url: 'order',
                        icon: require('@/assets/icon/my01.png'),
                        iconOn: require('@/assets/icon/my02.png'),
                        activeArray: ['order','orderDetail']
                    },
                    {
                        name: '客服中心',
                        url: 'contact',
                        icon: require('@/assets/icon/my03.png'),
                        iconOn: require('@/assets/icon/my04.png'),
                        activeArray: ['contact']
                    },
                    {
                        name: '企业认证',
                        url: 'identity',
                        icon: require('@/assets/icon/my05.png'),
                        iconOn: require('@/assets/icon/my06.png'),
                        activeArray: ['identity']
                    }
                ]
            }
        },
        watch:{
            '$route.query.type': {
                handler(newVal,oldVal){
                    this.getNavIndex()
                    console.log(newVal,oldVal)
                },
                deep: true
            }
        },
        mounted(){
            this.getNavIndex()
        },
        methods: {
            // 左侧点击
            myNavTap(e){
                this.$router.push({ query:{type: e.url} })
            },
            // 页面进入时判断左侧位置
            getNavIndex(){
                this.myNavData.map((el,index) => {
                    el.activeArray.map((item) => {
                        if(item == this.$route.query.type){
                            this.active = index
                        }
                    })
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .myContent{
        width: 100vw;
        border-top: 1px solid #F6F7F9;
        display: flex;
        .myNavBox{
            width: 200px;
            height: calc(100vh - 85px);
            background: #F7F8FA;
            overflow-y: scroll;
            scrollbar-width: none; /* firefox */
            -ms-overflow-style: none; /* IE 10+ */
            &::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
            .myNav{
                padding: 18px 20px;
                cursor: pointer;
                .myNavIcon{
                    width: 20px;
                    height: 20px;
                }
                .myNavName{
                    font: 14px/20px "Microsoft YaHei";
                    padding-left: 10px;
                }
            }
        }
        .myComponents{
            flex: 1;
            height: calc(100vh - 85px);
            padding: 0 35px 0 20px;
            overflow-y: scroll;
            scrollbar-width: none; /* firefox */
            -ms-overflow-style: none; /* IE 10+ */
            &::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
        }
    }
</style>